import React from 'react';

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>About us</h1>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Amet aliquam
        quidem quam eligendi. Dolorem, cumque veniam! Ipsa quo quisquam, laborum
        praesentium nulla dolor architecto voluptatibus nam itaque facere,
        repellat dolorem.
      </p>
    </section>
  );
};

export default About;
